import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { group: "Operations", items: [
    { to: "/", label: "Faculty Directory", icon: "▤", end: true },
    { to: "/add", label: "Add New Faculty", icon: "＋" },
    { to: "/bulk-import", label: "Bulk CSV Import", icon: "⇧" },
  ]},
  { group: "Insights", items: [
    { to: "/summary", label: "Executive Summary", icon: "◉" },
    { to: "/strength", label: "Department Strength", icon: "▦" },
    { to: "/compliance", label: "NMC Compliance", icon: "✓" },
    { to: "/pipeline", label: "Promotion Pipeline", icon: "↗" },
  ]},
  { group: "Reference", items: [
    { to: "/schema", label: "Data Dictionary", icon: "≡" },
  ]},
  { group: "Restricted", items: [
    { to: "/inspection", label: "Inspection Readiness", icon: "⚑", confidential: true },
    { to: "/aebas-discrepancies", label: "AEBAS Discrepancies", icon: "⇄", admin: true },
    { to: "/access-requests", label: "Access Requests", icon: "⊕", admin: true },
  ]},
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const initials = (user?.name || "?").split(" ").map(s => s[0]).join("").slice(0,2).toUpperCase();
  const isAdmin = user?.role === "admin" || user?.role === "confidential";

  return (
    <aside className="sidebar" data-testid="sidebar">
      <div className="sb-brand">
        <div className="sb-mark">F</div>
        <div>
          <div className="sb-title">FIMS</div>
          <div className="sb-sub">SSMCH · AY 25-26</div>
        </div>
      </div>

      {NAV.map(group => {
        const visibleItems = group.items.filter(item => !item.admin || isAdmin);
        if (visibleItems.length === 0) return null;
        return (
          <div key={group.group}>
            <div className="sb-group-title">{group.group}</div>
            {visibleItems.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({isActive}) => `sb-link ${item.confidential ? 'confidential' : ''} ${isActive ? 'active' : ''}`}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <span className="sb-icon">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        );
      })}

      <div className="sb-user" data-testid="sidebar-user">
        <div className="sb-user-av">{initials}</div>
        <div style={{minWidth:0}}>
          <div className="sb-user-name" style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',maxWidth:120}}>{user?.name}</div>
          <div className="sb-user-role">{user?.role}</div>
        </div>
        <button className="sb-logout" onClick={logout} data-testid="logout-btn">Sign out</button>
      </div>
    </aside>
  );
}
